import { createRouter, createWebHistory } from 'vue-router'
import authRoutes from './authRoutes'
import meusDadosRoutes from './meusDadosRoutes'
import dashboardRoutes from './dashboardRoutes'
import pedidosRoutes from './pedidosRoutes'
import assistenciaTecnicaRoutes from './assistenciaTecnicaRoutes'
import usuariosRoutes from './usuariosRoutes'
import perfisRoutes from './perfisRoutes'
import revendedorRoutes from './revendedorRoutes'
import revendaRoutes from './revendaRoutes'
import mensagemRoutes from './mensagemRoutes'
import configuracaoRoutes from './configuracaoRoutes'
import marketingRoutes from './marketingRoutes'
import botControleRoutes from './botControleRoutes'
import { setupPageAccessGuard } from './pageAccessGuard'
import boletosRoutes from './boletosRoutes'

import { useAuthStore } from '@/stores/auth'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
    },
    authRoutes,
    meusDadosRoutes,
    dashboardRoutes,
    pedidosRoutes,
    assistenciaTecnicaRoutes,
    usuariosRoutes,
    perfisRoutes,
    revendedorRoutes,
    revendaRoutes,
    mensagemRoutes,
    configuracaoRoutes,
    marketingRoutes,
    boletosRoutes,
    botControleRoutes,
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: () => import('../views/sistema/PaginaNaoEncontradaView.vue'),
    },
    {
      path: '/sem-autorizacao',
      name: 'sem-autorizacao',
      component: () => import('../views/sistema/PaginaSemAutorizacaoView.vue'),
    },
  ],
})

// guardião de navegação global
router.beforeEach((to, from, next) => {
  const isPublic = to.matched.some((record) => record.meta.public)
  const token = localStorage.getItem('access_token')

  if (!isPublic && !token) {
    return next('/login')
  }

  // Se estiver indo para a página de login, mas já estiver autenticado, redirecione para a página inicial
  if (to.path === '/login' && token) {
    return next('/')
  }

  next()
})

// Verificar o guardião de autenticação
router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    const authStore = useAuthStore()
    if (!authStore.isAuthenticated) {
      next({ name: 'login', query: { redirect: to.fullPath } })
      return
    }
  }
  next()
})

// Setup page access guard
setupPageAccessGuard(router)

export default router
